import React, { useEffect, useRef, useState } from 'react';
import styles from './componentCss/ExpertiseTiles.module.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from './Button';

const useFadeInOnScroll = () => {
    const ref = useRef();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(node);
                }
            },
            { threshold: 0.1 }
        );

        observer.observe(node);

        return () => {
            if (node) observer.unobserve(node); 
        };
    }, []);

    return [ref, isVisible];
};

const FadeInSection = ({ children }) => {
    const [ref, isVisible] = useFadeInOnScroll();

    return (
        <div
            ref={ref}
            className={`${styles.fadeInSection} ${isVisible ? styles.isVisible : ''}`}
        >
            {children}
        </div>
    );
};

const ExpertiseTiles = ({ tiles }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.expertiseSection}>
            <h2 className={styles.sectionTitle}>{t('OurServices')}</h2>
            <div className={styles.sectionBar}></div>
            <div className={styles.tilesRow}>
                {tiles.map((tile, index) => (
                    <FadeInSection key={index}>
                        <div className={styles.tile}>
                            <div className={styles.tileHeader}>
                                {tile.image && (
                                    <img
                                        src={tile.image}
                                        alt={`${tile.title} icon`}
                                        className={styles.tileIcon}
                                    />
                                )}
                                <div className={styles.tileTitle}>{tile.title}</div>
                            </div>
                            <div className={styles.tileDesc}>{tile.description}</div>
                            {tile.href && (
                                <div className={styles.tileCta}>
                                    <Button href={tile.href} fontSize={'0.95rem'} fontWeight={600}>
                                        {t('LearnMore')}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </FadeInSection>
                ))}
            </div>
        </div>
    );
};

export default ExpertiseTiles;
